import {Platform} from 'react-native';

/** Height used when sliding the tab bar off-screen (hide chrome). */
export const getTabBarSlideOffset = theme =>
  Platform.OS === 'web' ? theme.tabBarHeight : theme.navHeight;

/** Scroll/content padding so lists clear the bottom tab bar. */
export const getTabBarBottomInset = theme =>
  Platform.OS === 'web' ? theme.tabBarHeight : theme.navHeight;

export const getBottomTabBarStyles = theme => ({
  backgroundColor: theme.colors.navBackground,
  borderTopWidth: 0,
  ...(Platform.OS === 'web'
    ? {
        // BottomTabBar always injects height from getTabBarHeight() (default 49px) before
        // tabBarStyle; only a numeric height here overrides that and stops label clipping.
        height: theme.tabBarHeight,
        paddingBottom: 5,
        paddingTop: 5,
        overflow: 'visible',
      }
    : {
        height: theme.navHeight,
        paddingBottom: 5,
        paddingTop: 3,
      }),
  shadowColor: theme.colors.shadow,
  shadowOpacity: theme.name === 'darkTheme' ? 0 : 0.4,
  shadowOffset: {width: 0, height: -1},
  shadowRadius: 10,
  elevation: 5,
});
